import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ServicePage.css';
import { setPageMeta } from '../utils/seo';

const Mentora = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta(
      'MENTORA – Corporate Training by HRCONSOL',
      'MENTORA builds future-ready talent with expert-led programs, TNA, mini-series talks, and customized learning journeys for organizations.'
    );
  }, []);

  return (
    <div className="service-page mentora-theme">
      <div className="service-hero">
        <div className="container">
          <h1>MENTORA – Building Brains. Shaping Future.</h1>
          <p className="subtitle">A Corporate Training Initiative by HRCONSOL Pvt Ltd</p>
        </div>
      </div>

      <div className="container">
        <div className="service-content">
          <div className="service-section">
            <h2>About <span className="mentora-word">MENTORA</span></h2>
            <p>MENTORA, powered by HRCONSOL – Redefining HR Solutions, is a next-generation corporate training and learning platform designed to build future-ready talent for organizations and professionals across industries.</p>
            <p>Our philosophy centers on the growth mindset, driving skill enhancement, leadership readiness, and sustainable performance through data-driven learning interventions. We empower people and businesses to adapt, evolve, and excel in an era of digital transformation, innovation, and disruption.</p>
          </div>

          <div className="service-section">
            <h2>Our Philosophy – GROWTH MINDSET</h2>
            <ul className="benefits-list">
              <li><strong>M – Maximizing:</strong> Empowering individuals and teams to realize their full potential</li>
              <li><strong>E – Employee:</strong> People-centric learning focused on capability and performance</li>
              <li><strong>N – Next-Gen:</strong> Future-focused skills for emerging industries</li>
              <li><strong>T – Talent:</strong> Strategic development of high-performing professionals</li>
              <li><strong>O – Organizational:</strong> Aligning learning with business goals</li>
              <li><strong>R – Readiness:</strong> Preparing teams for change and innovation</li>
              <li><strong>A – Advancement:</strong> Driving professional growth and career mobility</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Industries We Serve</h2>
            <p>MENTORA proudly partners with organizations from diverse sectors to build capability and drive excellence:</p>
            <ul className="benefits-list" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
              <li>FMCG, Manufacturing & Textiles</li>
              <li>Telecom & IT</li>
              <li>Banking & Financial Services</li>
              <li>Healthcare & Pharmaceuticals</li>
              <li>NGOs & Development Sector</li>
              <li>Hospitality, Retail & Customer Service</li>
              <li>Energy, Construction & Engineering</li>
              <li>Educational Institutes & Universities</li>
              <li>Startups & SMEs</li>
            </ul>
            <p>Our tailored programs help bridge skills gaps, strengthen leadership pipelines, and align learning with organizational strategy.</p>
          </div>

          <div className="service-section">
            <h2>Core Training Portfolios</h2>
            <p>We offer a broad range of learning solutions across technical, behavioral, and strategic domains:</p>
            <div className="process-steps">
              <div className="step">
                <h3>Digital & Technical Skills</h3>
                <ul className="package-list">
                  <li>Digital Transformation & AI Adoption</li>
                  <li>Data Literacy & Business Analytics</li>
                  <li>Cybersecurity Awareness</li>
                  <li>Ethical AI & Responsible Innovation</li>
                  <li>Sustainability & Green Skills</li>
                </ul>
              </div>
              <div className="step">
                <h3>Leadership & Management Excellence</h3>
                <ul className="package-list">
                  <li>Agile & Project Management</li>
                  <li>Change Management & Adaptability</li>
                  <li>Strategic Thinking & Decision-Making</li>
                  <li>Leadership for Remote & Hybrid Teams</li>
                  <li>Coaching & Mentoring for Leaders</li>
                </ul>
              </div>
              <div className="step">
                <h3>People & Culture Development</h3>
                <ul className="package-list">
                  <li>Emotional Intelligence (EQ)</li>
                  <li>Diversity, Equity & Inclusion (DEI)</li>
                  <li>Communication & Presentation Skills</li>
                  <li>Workplace Wellness & Stress Management</li>
                  <li>Time Management & Productivity</li>
                </ul>
              </div>
              <div className="step">
                <h3>Cross-Functional & Industry Programs</h3>
                <ul className="package-list">
                  <li>Fire Safety & Emergency Response</li>
                  <li>Cross-Cultural Competency</li>
                  <li>Professional Language & Business Writing</li>
                  <li>Corporate English (Spoken & Written)</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>Mini Series Talks – Quick Learning, Big Impact</h2>
            <p>Short, 1–2 hour interactive sessions ideal for leadership huddles, townhalls, and offsite retreats. Each session is designed to inspire, engage, and empower teams.</p>
            <ul className="benefits-list">
              <li>The Growth Mindset Reset</li>
              <li>Future-Focused Leadership</li>
              <li>Resilience in Uncertain Times</li>
              <li>Digital Transformation: A Human Perspective</li>
              <li>Wellbeing at Work</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Training Needs Analysis (TNA)</h2>
            <p>Our TNA framework ensures every training investment delivers measurable results. We analyze skills gaps, align programs with strategic goals, and track ROI through performance metrics.</p>
            <ul className="benefits-list">
              <li>Data-driven learning priorities</li>
              <li>Customized pathways by role and function</li>
              <li>Improved engagement and retention</li>
              <li>Strategic alignment with business goals</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Positive Impact & Results</h2>
            <ul className="benefits-list">
              <li><span className="benefit-heading">45% increase</span> in team productivity within 3 months</li>
              <li><span className="benefit-heading">60% improvement</span> in leadership effectiveness post-training</li>
              <li><span className="benefit-heading">30% drop</span> in turnover through engagement-focused programs</li>
              <li><span className="benefit-heading">90% learner satisfaction</span> score across industries</li>
              <li>Strengthened employer branding through continuous development</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Packages & Custom Solutions</h2>
            <div className="process-steps">
              <div className="step package-card">
                <h3>1. WORKSHOP</h3>
                <p>Single Training Session (1-Day)</p>
                <ul className="package-list">
                  <li>Fee: PKR 150,000 - 250,000</li>
                  <li>1-day interactive workshop</li>
                  <li>Training materials & handouts</li>
                  <li>Certificate of participation</li>
                  <li>Post-training Q&A support (1 week)</li>
                </ul>
                <p className="package-note">Perfect for one-time skill development sessions.</p>
                <button onClick={() => navigate('/#contact')} className="package-button">Choose Plan</button>
              </div>

              <div className="step package-card">
                <h3>2. PROGRAM</h3>
                <p>Multi-Session Training (3-5 Days)</p>
                <ul className="package-list">
                  <li>Fee: PKR 300,000 - 500,000</li>
                  <li>Comprehensive training program</li>
                  <li>Pre & post-training assessments</li>
                  <li>Digital resources & e-learning access</li>
                  <li>Certificate of completion</li>
                  <li>1-month post-training support</li>
                </ul>
                <p className="package-note">Ideal for in-depth skill development programs.</p>
                <button onClick={() => navigate('/#contact')} className="package-button">Choose Plan</button>
              </div>

              <div className="step package-card">
                <h3>3. ANNUAL PARTNERSHIP</h3>
                <p>Ongoing Training Support (12 Months)</p>
                <ul className="package-list">
                  <li>Fee: PKR 800,000 - 1,000,000/year</li>
                  <li>Unlimited training sessions</li>
                  <li>Custom program development</li>
                  <li>Leadership coaching</li>
                  <li>E-learning platform access</li>
                  <li>Quarterly training needs assessment</li>
                  <li>Dedicated training coordinator</li>
                </ul>
                <button onClick={() => navigate('/#contact')} className="package-button">Choose Plan</button>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>Why Partner with MENTORA?</h2>
            <ul className="benefits-list">
              <li>Purpose-Built Content: Designed around real market needs</li>
              <li>Flexible Delivery: On-site, online, or blended learning</li>
              <li>Expert Trainers: Delivered by certified industry practitioners</li>
              <li>Measurable ROI: Impact tracking via performance metrics</li>
              <li>Customized Learning Journeys: Built around your organization’s culture and goals</li>
            </ul>
          </div>

          <div className="service-cta">
            <h2>Bring Mentora to Your Team</h2>
            <p>Request a customized training plan for your organization or join our upcoming public programs.</p>
            <button onClick={() => navigate('/#contact')} className="cta-button">Get Started</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mentora;
